import React from "react";
import {Navigate, Route, Routes} from "react-router";
import {routes} from "../routes.js";
import CookieService from "../service/cookieService.js";

const cookieService = CookieService.getService();

class Auth extends React.Component {
  redirectToHomePage = () => {
    const {navigate} = this.props;
    if (navigate) {
      navigate("/app", {replace: true});
    }
  };

  componentDidMount() {
    document.body.classList.add("bg-default");

    if (cookieService.isTokenAvailable()) {
      this.redirectToHomePage();
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("bg-default");
  }

  getRoutes = () => {
    const authRoutes = routes.filter((route) => route.layout === "/auth");
    return authRoutes.map((prop, key) => {
      const {path, component: Component} = prop;
      return <Route path={path} element={<Component />} key={key} />;
    });
  };

  render() {
    return (
      <>
        <Routes>
          {this.getRoutes(routes)}
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </>
    );
  }
}

export default Auth;
